import React, { useEffect } from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';
import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';
import { useDispatch, useSelector } from 'hooks/store';
import { cleanClientsAction, getClientsListAction, remoteTotalSelector } from 'state/slices/clients';
import { usePagination } from 'hooks/pagination';
import { Client, PaginationData } from 'constants/interface';

import {
  DetailPage,
  ListPage,
} from './pages';

const ViewPage = (): JSX.Element => {
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const remoteTotal = useSelector(remoteTotalSelector);

  const remoteFetch = (
    paginationData: PaginationData,
  ) => {
    dispatch(getClientsListAction(paginationData));
  };
  const pagination = usePagination<Client>(
    remoteFetch,
  );

  useEffect(() => {
    dispatch(cleanClientsAction());
  }, []);

  useEffect(() => {
    pagination.updateTotal(remoteTotal);
  }, [remoteTotal]);

  return (
    <Switch>
      <Route path={`${path}${ROUTES.dashboard.clients.detail.root}`} render={() => <DetailPage onUpdateFinish={pagination.fetch} />} />
      <Route path={`${path}`} render={() => <ListPage pageData={pagination.getInternal()} onTableChange={pagination.onTableChange} onSearch={pagination.onSearch} />} />
    </Switch>
  );
};

export default ViewPage;
